import { FC, ReactNode } from 'react';
import { Section, Bullets } from 'components';
import S from 'page-components/program/BenefitsSection.Styled';
import { BulletsLabeled, BulletsSection } from 'components/BulletsLabeled';

interface BenefitsSectionProps<T extends boolean = boolean> {
  backgroundColor?: string;
  heading: string;
  subHeading?: string;
  footer?: ReactNode;
  bullets: T extends true ? BulletsSection[] : ReactNode[];
  isListLabeled?: T;
}

export const BenefitsSection: FC<BenefitsSectionProps> = ({
  backgroundColor,
  heading,
  subHeading,
  bullets,
  footer,
  isListLabeled = false,
}) => (
  <Section backgroundColor={backgroundColor}>
    <S.Content>
      <S.Headings>
        <S.Heading>{heading}</S.Heading>
        {subHeading && <S.SubHeading>{subHeading}</S.SubHeading>}
      </S.Headings>
      <S.BulletsContainer labeled={isListLabeled}>
        {isListLabeled && <BulletsLabeled sections={bullets} />}
        {isListLabeled || <Bullets bullets={bullets} />}
      </S.BulletsContainer>
    </S.Content>
    {footer && <S.Footer>{footer}</S.Footer>}
  </Section>
);
